
/**
 *
 * dark: 暗黑模式
 * white: 白色模式
 *
 * */
export const theme = {
    dark: {
        // 全局背景、字色
        'primary-background-color': "#161924",
        'primary-text-color': "#BDD0F1",

        // 全局滚动条背景色
        'primary-scrollbar-thumb-track': 'rgba(0, 0, 0, 0.1)',
        'primary-scrollbar-thumb-thumb': 'rgba(0, 0, 0, 0.3)',

        // 数据中心
        'primary-module-background-color': '#343D4E',
        'primary-box-shadow': 'rgba(33, 33, 33, 0.25)',
        'primary-select-title': 'rgba(136, 149, 182, 0.6)',
        'primary-box-border-color': 'rgba(61, 74, 111, 1)',
        'primary-select-tab-color': '#bdd0f1',

        // 常见问题、相关安装、APP使用
        'primary-input-background': '#353B47',
        'primary-input-text-color': '#BDD0F1',
        'primary-active-text-color': 'rgba(11, 186, 180, 1)',
        'primary-linear-gradient': 'linear-gradient(180deg, #1F2531 0%, rgba(31, 37, 49, 0) 100%)',
        'primary-transform-text-color': 'rgba(189, 208, 241, 1)',
        'primary-drawer-background':'#384357',
        'primary-drawer-box-shadow': 'rgba(221, 221, 221, 0)'

    },
    white: {
        // 全局背景、字色
        'primary-background-color': "#F6F6F8",
        'primary-text-color': "#2D3748",

        // 全局滚动条背景色
        'primary-scrollbar-thumb-track': 'rgba(255, 255, 255, 0.1)',
        'primary-scrollbar-thumb-thumb': 'rgba(255, 255, 255, 0.3)',

        // 数据中心
        'primary-module-background-color': '#ffffff',
        'primary-box-shadow': 'rgba(184,196,212,0.12)',
        'primary-select-title': '#999999',
        'primary-box-border-color': 'rgba(61, 74, 111, 0.2)',
        'primary-select-tab-color': '#999999',

        // 常见问题、相关安装、APP使用
        'primary-input-background': '#efefef',
        'primary-input-text-color': 'rgba(45, 55, 72, 0.33)',
        'primary-active-text-color': 'rgba(22, 119, 255, 1)',
        'primary-linear-gradient': 'linear-gradient(180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%)',
        'primary-transform-text-color': 'rgba(45, 55, 72, 0.5)',
        'primary-drawer-background':'#FFFFFF',
        'primary-drawer-box-shadow': '#DDDDDD'
    }
}
